// Extended country flags mapping for player nationalities
export const COUNTRY_FLAGS: Record<string, string> = {
  // Europe
  'England': '🏴󠁧󠁢󠁥󠁮󠁧󠁿',
  'Scotland': '🏴󠁧󠁢󠁳󠁣󠁴󠁿',
  'Wales': '🏴󠁧󠁢󠁷󠁬󠁳󠁿',
  'Northern Ireland': '🇬🇧',
  'Republic of Ireland': '🇮🇪',
  'Ireland': '🇮🇪',
  'Spain': '🇪🇸',
  'Germany': '🇩🇪',
  'France': '🇫🇷',
  'Italy': '🇮🇹',
  'Portugal': '🇵🇹',
  'Netherlands': '🇳🇱',
  'Belgium': '🇧🇪',
  'Croatia': '🇭🇷',
  'Serbia': '🇷🇸',
  'Poland': '🇵🇱',
  'Ukraine': '🇺🇦',
  'Austria': '🇦🇹',
  'Switzerland': '🇨🇭',
  'Denmark': '🇩🇰',
  'Sweden': '🇸🇪',
  'Norway': '🇳🇴',
  'Finland': '🇫🇮',
  'Czech Republic': '🇨🇿',
  'Czechia': '🇨🇿',
  'Hungary': '🇭🇺',
  'Romania': '🇷🇴',
  'Greece': '🇬🇷',
  'Turkey': '🇹🇷',
  'Russia': '🇷🇺',
  'Albania': '🇦🇱',
  'Slovenia': '🇸🇮',
  'Slovakia': '🇸🇰',
  'Bosnia and Herzegovina': '🇧🇦',
  'Bosnia': '🇧🇦',
  'Montenegro': '🇲🇪',
  'North Macedonia': '🇲🇰',
  'Bulgaria': '🇧🇬',
  'Iceland': '🇮🇸',
  'Kosovo': '🇽🇰',
  'Georgia': '🇬🇪',
  'Armenia': '🇦🇲',
  'Azerbaijan': '🇦🇿',
  'Latvia': '🇱🇻',
  'Lithuania': '🇱🇹',
  'Estonia': '🇪🇪',
  'Luxembourg': '🇱🇺',
  'Cyprus': '🇨🇾',
  'Malta': '🇲🇹',

  // South America
  'Brazil': '🇧🇷',
  'Argentina': '🇦🇷',
  'Uruguay': '🇺🇾',
  'Colombia': '🇨🇴',
  'Chile': '🇨🇱',
  'Ecuador': '🇪🇨',
  'Peru': '🇵🇪',
  'Paraguay': '🇵🇾',
  'Venezuela': '🇻🇪',
  'Bolivia': '🇧🇴',

  // Africa
  'Morocco': '🇲🇦',
  'Algeria': '🇩🇿',
  'Tunisia': '🇹🇳',
  'Egypt': '🇪🇬',
  'Senegal': '🇸🇳',
  'Nigeria': '🇳🇬',
  'Ghana': '🇬🇭',
  'Cameroon': '🇨🇲',
  'Ivory Coast': '🇨🇮',
  "Côte d'Ivoire": '🇨🇮',
  'Mali': '🇲🇱',
  'DR Congo': '🇨🇩',
  'Congo DR': '🇨🇩',
  'South Africa': '🇿🇦',
  'Guinea': '🇬🇳',
  'Burkina Faso': '🇧🇫',
  'Gabon': '🇬🇦',
  'Equatorial Guinea': '🇬🇶',
  'Cape Verde': '🇨🇻',
  'Angola': '🇦🇴',
  'Mozambique': '🇲🇿',
  'Zimbabwe': '🇿🇼',
  'Zambia': '🇿🇲',

  // Asia
  'Japan': '🇯🇵',
  'South Korea': '🇰🇷',
  'Korea Republic': '🇰🇷',
  'China': '🇨🇳',
  'Iran': '🇮🇷',
  'Saudi Arabia': '🇸🇦',
  'Australia': '🇦🇺',
  'New Zealand': '🇳🇿',
  'Israel': '🇮🇱',
  'United Arab Emirates': '🇦🇪',
  'Qatar': '🇶🇦',

  // North/Central America
  'USA': '🇺🇸',
  'United States': '🇺🇸',
  'Mexico': '🇲🇽',
  'Canada': '🇨🇦',
  'Jamaica': '🇯🇲',
  'Costa Rica': '🇨🇷',
  'Honduras': '🇭🇳',
  'Panama': '🇵🇦',
  'Trinidad and Tobago': '🇹🇹',
  'Curaçao': '🇨🇼',
  'Curacao': '🇨🇼',

  // Fallback
  'Europe': '🇪🇺',
}

export function countryToEmoji(nationality: string | null | undefined): string {
  if (!nationality) return ''
  return COUNTRY_FLAGS[nationality] || ''
}

export function calculateAge(dob: string | null | undefined): number | null {
  if (!dob) return null
  const birthDate = new Date(dob)
  const today = new Date()
  let age = today.getFullYear() - birthDate.getFullYear()
  const monthDiff = today.getMonth() - birthDate.getMonth()
  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
    age--
  }
  return age
}

export function classifyPosition(position: string | null | undefined): 'GK' | 'DEF' | 'MID' | 'FWD' {
  if (!position) return 'MID'

  const pos = position.toUpperCase()
  if (pos === 'G' || pos === 'GK' || pos.includes('GOALKEEPER')) return 'GK'
  if (pos === 'D' || pos.includes('DEFENDER') || ['CB', 'LB', 'RB', 'LWB', 'RWB'].includes(pos)) return 'DEF'
  if (pos === 'M' || pos.includes('MIDFIELDER') || ['CM', 'CDM', 'CAM', 'LM', 'RM', 'DM', 'AM'].includes(pos)) return 'MID'
  if (pos === 'F' || pos === 'A' || pos.includes('FORWARD') || pos.includes('ATTACKER') || ['ST', 'CF', 'LW', 'RW', 'SS'].includes(pos)) return 'FWD'

  return 'MID'
}
